import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@mui/material';

interface HowToBuyProps {
  shouldShowHeader?: boolean;
}

export const HowToBuy: FunctionComponent<HowToBuyProps> = (props) => {
  const goToPurchase = () =>
    document.getElementById('purchase').scrollIntoView();
  return (
    <Box>
      {props.shouldShowHeader && (
        <Typography variant="h2" align="center">
          Jak kupić?
        </Typography>
      )}
      <ol>
        {props.shouldShowHeader && (
          <li>
            <Typography color="textSecondary">Wybierz swój kurs</Typography>
            <ul>
              <li onClick={goToPurchase}>
                <Typography color="textSecondary">
                  Egzamin Ósmoklasisty
                </Typography>
              </li>
              <li onClick={goToPurchase}>
                <Typography color="textSecondary">Matura</Typography>
              </li>
            </ul>
          </li>
        )}
        <li>
          <Typography color="textSecondary">
            Podaj swoje imię i nazwisko, e-mail oraz ustal hasło którym będziesz
            się logować do kursu.
          </Typography>
        </li>
        <li>
          <Typography color="textSecondary">
            Po zatwierdzeniu danych zostaniesz przekierowany do płatności.
          </Typography>
        </li>
        <li>
          <Typography color="textSecondary">
            Od razu po pozytywnie zakończonej transakcji pojawi się strona z
            potwierdzeniem płatności oraz linkiem do pobrania aplikacji.
          </Typography>
        </li>
        <li>
          <Typography color="textSecondary">
            Wystarczy kliknąć, pobrać aplikację i zalogować się do naszego
            kursu.
          </Typography>
        </li>
      </ol>
    </Box>
  );
};

export default HowToBuy;
